import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SvgIcon from "../SvgIcon/SvgIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CloseButton',
  props: {
    inverted: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["absolute z-[15] flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border p-0 outline-none before:absolute before:h-[calc(100%_+_10px)] before:w-[calc(100%_+_10px)] before:rounded-full before:border-2 before:border-transparent focus-visible:before:border-black active:before:border-black", [__props.inverted ? 'bg-white text-black' : 'border-transparent bg-black text-white']])
  }, [
    _createVNode(SvgIcon, {
      "icon-name": "close-fat",
      class: "h-3.5 w-3.5"
    })
  ], 2))
}
}

})